import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on COMPANY
  fetchCompanies: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchCompanies';

    commit(`${mutationPrefix}Pending`);

    return api.fetchCompanies(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on COMPANY
  fetchSingleCompany: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchSingleCompany';

    commit(`${mutationPrefix}Pending`);

    return api.fetchSingleCompany(args)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`, response.entity);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on COMPANY (done by admin)
  createCompany: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createCompany';

    commit(`${mutationPrefix}Pending`);

    return api.createCompany(args)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`, response.entity);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on COMPANIES
  updateCompany: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateCompany';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateCompany(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on COMPANIES (done by admin)
  deleteCompany: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deleteCompany';

    commit(`${mutationPrefix}Pending`, id);

    return api.deleteCompany(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  setContext: ({ commit }, payload = null) => {
    commit('setContext', payload);
  },

  openFormModal: ({ commit }, payload = null) => {
    commit('openFormModal', payload);
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/company/actions.js